import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

function PipelineProgress({ stages = [], status = 'ready', activeIndex = 0 }) {
  const { colors } = useTheme();
  const items = stages.length ? stages : ['Upload', 'Analyze', 'Generate', 'Review'];

  const styles = useMemo(() => StyleSheet.create({
    wrap: {
      borderWidth: 1,
      borderColor: colors.border_color_secondary,
      borderRadius: 12,
      backgroundColor: colors.solid_color_tertiary,
      padding: 12,
      gap: 10,
    },
    row: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
    },
    step: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 10,
      paddingVertical: 7,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: colors.border_color_secondary,
      backgroundColor: colors.solid_color_block,
    },
    stepActive: {
      borderColor: colors.text_color_primary,
    },
  }), [colors]);

  return (
    <View style={styles.wrap}>
      <Text size='s' color='secondary' weight='bold'>Pipeline: {status}</Text>
      <View style={styles.row}>
        {items.map((stage, index) => {
          const label = typeof stage === 'string' ? stage : (stage.label || stage.title || `Step ${index + 1}`);
          const isActive = index === activeIndex;
          return (
            <View key={`${label}-${index}`} style={[styles.step, isActive && styles.stepActive]}>
              <Icon name={isActive ? 'spinner' : 'circle-check'} size={11} color={colors.text_color_secondary} />
              <Text size='xs' color='secondary'>{label}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}

export default React.memo(PipelineProgress);
